import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import citizenTrainedListAction from './citizenTrainedList.action.json' with { type: 'json' }
import { trainingPerformedObject } from '../citizenTrainedObject'

export const citizenTrainedExpression = expression(trainingPerformedObject.shape)

const citizenTrainedListDefinition = defineAction({
  ...citizenTrainedListAction,

  input: z.object({
    filter: citizenTrainedExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: z.string().nullish(),
    order: z.string().nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({ items: z.array(trainingPerformedObject), count: z.number() }),
})

export default citizenTrainedListDefinition
